import React from 'react'
import { motion } from 'framer-motion'

import Image from '../../../assets/images/ddxpage/impact.webp'

const Impact = () => {
  return (
    <section className="w-full">
      <div
      className="relative flex min-h-[180px] w-full items-center justify-center overflow-hidden md:min-h-[250px] lg:min-h-[280px] xl:min-h-[300px] 2xl:min-h-[400px]"
      >
        {/* Background */}
        <img
          src={Image}
          alt="Final Note Background"
          className="absolute inset-0 h-full w-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-white/10 backdrop-blur-[1px]" />

        {/* Content */}
        <div className="relative z-10 flex w-full max-w-[1600px] flex-col items-center justify-center px-6 py-10 text-center md:px-10">
          {/* Heading */}
          <motion.div
            initial={{
              opacity: 0,
              y: 60,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{
              duration: 0.7,
              delay: 0.2,
              ease: 'easeOut',
            }}
            className="items-center"
          >
            <h2 className="font-gilroy-bold text-2xl text-black md:text-4xl xl:text-5xl">
              Impact
            </h2>
          </motion.div>

          {/* Paragraph */}
          <motion.p
            initial={{
              opacity: 0,
              y: 80,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{
              duration: 0.8,
              delay: 0.35,
              ease: 'easeOut',
            }}
            className="mt-2 font-gilroy-medium text-sm leading-[1.6] text-black/90 md:mt-6 md:text-xl lg:text-2xl 2xl:text-3xl"
          >
            DDX reduces time-to-diagnosis, improves decision confidence,
            and enables proactive healthcare behavior. It transforms how
            users engage with their health—making diagnosis faster,
            smarter, and more accessible.
          </motion.p>
        </div>
      </div>
    </section>
  )
}

export default Impact